import styled from 'styled-components';

export const Video = styled.video`
  width: 100%;
  height: 100%;
  max-height: ${props => props.isFullScreen ? '100vh' : '90vh'};
  //margin: ${props => props.hide ? 0 : '2px'};
  @media (max-width: 1075px) {
    max-height: 100vh;
    height: ${props => props.height ? `${props.height}px` : '100%'};
  }
`;